import React from 'react'
import PropTypes from 'prop-types'
import { Button, Stack, Tooltip, DialogActions } from '@mui/material'
import { noop } from 'lodash'
import T from 'T'
import CancelButton from '../../buttons/CancelButton'
import Loader from '../../common/loader'

const ScheduleStopDialogActions = ({
  onReset = noop,
  onCancel = noop,
  onSave = noop,
  onSaveMaster = noop,
  onPublishMasterSequence = noop,
  loading = false,
  masterLoading = false,
  publishLoading = false,
  isSaveDisabled = false,
  hidePublishMaster = false,
}) => {
  const isAnyLoading = loading || masterLoading || publishLoading

  return (
    <DialogActions sx={{ flex: '0 0 48px', pr: { xs: 10, sm: 10, md: 3 } }}>
      {isAnyLoading && <Loader />}
      <Stack direction="row" alignItems="center" justifyContent="flex-start" flex={1}>
        <Button size="small" variant="outlined" color="warning" onClick={onReset}>
          {T.RESET}
        </Button>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={2}>
        <CancelButton size="small" onClick={onCancel} />
        {!hidePublishMaster && (
          <Tooltip title={T.PUBLISH_MASTER_SEQUENCE_TOOLTIP} arrow>
            <span>
              <Button
                size="small"
                variant="outlined"
                loading={masterLoading}
                disabled={isSaveDisabled || isAnyLoading}
                onClick={onSaveMaster}
              >
                {T.EDIT_MASTER_SEQUENCE}
              </Button>
            </span>
          </Tooltip>
        )}
        {!hidePublishMaster && (
          <Tooltip title={T.SAVE_PERMANENT_TOOLTIP} arrow>
            <span>
              <Button
                size="small"
                variant="contained"
                loading={publishLoading}
                disabled={isSaveDisabled || isAnyLoading}
                onClick={onPublishMasterSequence}
              >
                {T.SAVE_PERMANENT}
              </Button>
            </span>
          </Tooltip>
        )}
        <Tooltip title="This change only affects today's daily schedule" arrow>
          <span>
            <Button size="small" variant="outlined" loading={loading} disabled={isSaveDisabled || isAnyLoading} onClick={onSave}>
              {T.SAVE_CURRENT_DAY}
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </DialogActions>
  )
}

ScheduleStopDialogActions.propTypes = {
  onReset: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  onSaveMaster: PropTypes.func,
  onPublishMasterSequence: PropTypes.func,
  loading: PropTypes.bool,
  masterLoading: PropTypes.bool,
  publishLoading: PropTypes.bool,
  isSaveDisabled: PropTypes.bool,
  hidePublishMaster: PropTypes.bool,
}

export default ScheduleStopDialogActions
